import { IFProjectState } from '../initState/InterfacesState';

export const MapStateToProps = ({
  header,
  alert,
  stories,
  calculator,
  widthWindow,
  offsetContent,
  blog,
  blogMain,
  blogPopular,
  logosPartners,
  advantagesSlider,
  advantagesSliderTitle,
  advantagesSliderNoFade,
  reviews,
  about,
  state404,
  blockedSend,
  recaptchaV2ref,
  textCards,
  iconCards,
  contactForms,
}: IFProjectState) => {
  return {
    header,
    alert,
    stories,
    calculator,
    widthWindow,
    offsetContent,
    blog,
    blogMain,
    blogPopular,
    logosPartners,
    advantagesSlider,
    advantagesSliderTitle,
    advantagesSliderNoFade,
    reviews,
    about,
    state404,
    blockedSend,
    recaptchaV2ref,
    textCards,
    iconCards,
    contactForms,
  };
};
